import { auth } from "leatherman-js";
import store from "@/store";

const canDelete = (resource) =>
  auth.hasPermission(store.getters["auth/getUser"], "delete", resource);
const canRead = (resource) => auth.hasPermission(store.getters["auth/getUser"], "read", resource);
const canWrite = (resource) => auth.hasPermission(store.getters["auth/getUser"], "write", resource);
const canRequestMigrations = () => {
  const client = store.getters["auth/getClient"];
  return (
    client.cloudServerCount ||
    client.colocationCount ||
    client.dedicatedServerCount ||
    client.domainCount ||
    client.enterpriseCloudCount ||
    client.otherCount ||
    client.planCount ||
    client.resellerHostingCount ||
    client.sharedHostingCount
  );
};
const canEditBilling = () =>
  auth.hasPermission(store.getters["auth/getUser"], "write", "addresses") &&
  auth.hasPermission(store.getters["auth/getUser"], "write", "creditcards") &&
  auth.hasPermission(store.getters["auth/getUser"], "write", "account");
const canCheckout = () =>
  auth.hasPermission(store.getters["auth/getUser"], "read", "orders") &&
  auth.hasPermission(store.getters["auth/getUser"], "write", "orders");
export { canDelete, canRead, canWrite, canRequestMigrations, canEditBilling, canCheckout };
